enum HostedFieldType {
    CardCode = 'cardCode',
    CardExpiry = 'cardExpiry',
    CardName = 'cardName',
    CardNumber = 'cardNumber',
    Note = 'note',
    Hidden = 'hidden',
}

export default HostedFieldType;
